import agenteConect from "@/assets/OP2P-CRM-e-Agentes-de-IA-agente-conecta.webp";
import agenteVoice from "@/assets/OP2P-CRM-e-Agentes-de-IA-agente-voice-ia.webp";
import agenteTracao from "@/assets/OP2P-CRM-e-Agentes-de-IA-agente-tracao.webp";
import agentePersonalizado from "@/assets/OP2P-CRM-e-Agentes-de-IA-agente-personalizado.webp";

export type Product = {
  slug: string;
  name: string;
  short: string;
  tagline: string;
  image: string;
  price: string;
  setup: string;
  agentes: string;
  features: string[];
  badges: string[];
  description: string;
};

export const PRODUCTS: Product[] = [
  {
    slug: "agente-connect",
    name: "Agente Connect",
    short: "Atendimento multi-departamento",
    tagline: "Automatize o atendimento com Agentes de IA especialistas.",
    image: agenteConect,
    price: "Proposta na demonstração",
    setup: "Implantação assistida, apresentada na reunião",
    agentes: "Agentes de IA (departamentos)",
    features: [
      "Agentes de IA (departamentos)",
      "Agentes de IA conforme a operação",
      "Atendimento inteligente pelo WhatsApp e Instagram",
      "Fluxos personalizados",
      "CRM com Kanbans movidos pela IA",
      "Follow-ups automáticos",
      "Organização e histórico dos contatos",
    ],
    badges: ["Multi-departamento", "CRM Inteligente", "Follow-ups"],
    description:
      "Agentes de IA prontos para atender, qualificar e encaminhar cada contato ao setor correto — com o CRM movido por IA incluído.",
  },
  {
    slug: "agente-voice-ia",
    name: "Agente Voice IA",
    short: "Texto + Voz + Prospecção",
    tagline: "Tudo do Connect com chamadas telefônicas por IA e prospecção ativa.",
    image: agenteVoice,
    price: "Proposta na demonstração",
    setup: "Implantação assistida, apresentada na reunião",
    agentes: "Agentes de IA (departamentos)",
    features: [
      "Agentes de IA (departamentos)",
      "Tudo do Agente Connect",
      "Chamadas telefônicas com IA",
      "Atendimento automatizado por voz",
      "Prospecção de novos clientes",
      "Follow-ups pelo WhatsApp, Instagram e telefone",
      "CRM com Kanbans movidos pela IA",
    ],
    badges: ["Chamadas por IA", "Voz + Texto", "Prospecção"],
    description:
      "Amplia a operação com voz humanizada: a IA faz e recebe ligações, prospecta e atualiza o CRM em tempo real.",
  },
  {
    slug: "agente-tracao-comercial",
    name: "IA + Tração Comercial",
    short: "Agente + CRM + LP + Tráfego",
    tagline: "Operação comercial completa: Agentes de IA, CRM, Landing Page e Tráfego Pago.",
    image: agenteTracao,
    price: "Proposta na demonstração",
    setup: "Implantação assistida, apresentada na reunião",
    agentes: "Agentes de IA (departamentos)",
    features: [
      "Agentes de IA (departamentos)",
      "Landing page dedicada",
      "Gestão de tráfego pago",
      "Prospecção de novos clientes",
      "Chamadas telefônicas com IA",
      "Atendimento e qualificação no WhatsApp e Instagram",
      "CRM com Kanbans movidos pela IA",
      "Funil comercial e follow-ups automáticos",
    ],
    badges: ["Agente de IA", "CRM Inteligente", "Landing Page", "Tráfego Pago"],
    description:
      "Do primeiro contato à venda: atendimento, qualificação, negociação e follow-up em um só sistema, orquestrados por IA.",
  },
  {
    slug: "agente-personalizado",
    name: "Agente Personalizado",
    short: "Sob medida para o seu negócio",
    tagline: "Um Agente de IA desenhado especificamente para o seu processo.",
    image: agentePersonalizado,
    price: "Proposta na demonstração",
    setup: "Implantação sob medida, apresentada na reunião",
    agentes: "Agentes de IA sob medida",
    features: [
      "Desenvolvimento sob medida",
      "Treinamento com os seus dados",
      "Integrações e APIs customizadas",
      "Fluxos exclusivos por operação",
      "CRM com Kanbans movidos pela IA",
      "Acompanhamento de resultados dedicado",
    ],
    badges: ["Sob medida", "Integrações", "CRM Inteligente"],
    description:
      "Quando os planos padrão não bastam, desenhamos um Agente de IA específico para o seu processo, com integrações exclusivas.",
  },
];

export const getProduct = (slug: string) => PRODUCTS.find((p) => p.slug === slug);
